var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6954 2.06464C9.88932 1.97845 10.1107 1.97845 10.3046 2.06464L17.5546 5.28686C17.8254 5.40724 18 5.67583 18 5.97222V17.25C18 17.6642 17.6642 18 17.25 18C16.8358 18 16.5 17.6642 16.5 17.25V6.45963L10 3.57074L3.5 6.45963V17.25C3.5 17.6642 3.16421 18 2.75 18C2.33579 18 2 17.6642 2 17.25V5.97222C2 5.67583 2.17455 5.40724 2.4454 5.28686L9.6954 2.06464ZM7.28894 8.3822C7.58067 8.09048 7.97633 7.92659 8.38889 7.92659H10C10.4126 7.92659 10.8082 8.09048 11.0999 8.3822C11.3917 8.67392 11.5556 9.06958 11.5556 9.48214V9.5377H14.0278C14.442 9.5377 14.7778 9.87349 14.7778 10.2877V16.7321C14.7778 17.1464 14.442 17.4821 14.0278 17.4821H5.97222C5.55801 17.4821 5.22222 17.1464 5.22222 16.7321V11.8988C5.22222 11.4846 5.55801 11.1488 5.97222 11.1488H6.83333V9.48214C6.83333 9.06958 6.99722 8.67392 7.28894 8.3822ZM6.72222 12.6488V15.9821H10.0556V12.6488H6.72222ZM10.0556 11.1488H8.33333V9.48214C8.33333 9.46741 8.33919 9.45328 8.34961 9.44286C8.36002 9.43244 8.37415 9.42659 8.38889 9.42659H10C10.0147 9.42659 10.0289 9.43244 10.0393 9.44286C10.0497 9.45328 10.0556 9.46741 10.0556 9.48214C10.0556 10.0377 10.0556 10.5933 10.0556 11.1488ZM11.5556 15.9821H13.2778V11.0377H11.5556V15.9821Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "ddb2d404a3aa6559f555fdbe502fcdf5.svg";
export { ForwardRef as ReactComponent };